import { render, staticRenderFns } from "./GiftsHospitalityAdmin.vue?vue&type=template&id=13b570a0&"
import script from "./GiftsHospitalityAdmin.vue?vue&type=script&lang=js&"
export * from "./GiftsHospitalityAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports